import React from 'react';
import { Typography, Grid, Box, Chip } from '@mui/material';
import { motion } from 'framer-motion';
import GradientText from '../shared/GradientText';
import AnimatedCard from '../shared/AnimatedCard';
import SectionWrapper from '../shared/SectionWrapper';
import { features } from '../../data/products';

const ProductsSection: React.FC = () => (
  <SectionWrapper id="features">
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.6 }}
    >
      <Box sx={{ mb: 10 }}>
        <Typography
          variant="overline"
          sx={{
            color: 'text.secondary',
            fontWeight: 600,
            letterSpacing: 3,
            fontSize: '0.7rem',
            mb: 3,
            display: 'block',
          }}
        >
          TOSTRUCTURE FOR MAC & WINDOWS
        </Typography>
        <GradientText
          variant="h2"
          sx={{ mb: 3, maxWidth: 500, fontSize: { xs: '2rem', md: '2.75rem' } }}
        >
          Everything you need to analyze data
        </GradientText>
        <Typography variant="body1" color="text.secondary" sx={{ maxWidth: 500 }}>
          A native desktop AI app for Mac and Windows that connects to your databases, generates insights
          through natural conversation, and delivers professional visualizations
          with full citation tracking.
        </Typography>
      </Box>
    </motion.div>

    <Grid container spacing={2.5}>
      {features.map((feature, i) => (
        <Grid size={{ xs: 12, sm: 6, md: 4 }} key={feature.title}>
          <AnimatedCard delay={i * 0.06}>
            <Box
              sx={{
                width: 3,
                height: 32,
                borderRadius: 2,
                bgcolor: feature.color,
                opacity: 0.6,
                mb: 2.5,
              }}
            />
            <Typography variant="h6" sx={{ mb: 1, fontWeight: 600, color: '#ffffff' }}>
              {feature.title}
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 3, lineHeight: 1.7 }}>
              {feature.description}
            </Typography>
            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.75 }}>
              {feature.highlights.map((h) => (
                <Chip
                  key={h}
                  label={h}
                  size="small"
                  sx={{
                    fontSize: '0.7rem',
                    bgcolor: 'rgba(255, 255, 255, 0.04)',
                    color: 'text.secondary',
                    border: '1px solid rgba(255, 255, 255, 0.06)',
                    fontWeight: 500,
                  }}
                />
              ))}
            </Box>
          </AnimatedCard>
        </Grid>
      ))}
    </Grid>
  </SectionWrapper>
);

export default ProductsSection;
